jQuery(function($){
    // Função robusta para lidar com o clique e garantir o redirecionamento correto
    const handleCustomizeClick = function(e) {
        const button = $(this);
        const url = button.attr("data-url");
        const page = button.attr("data-page") || "bm-product-customize";
        
        if (url) {
            // Interrompe outros scripts que possam estar interferindo
            e.preventDefault();
            e.stopImmediatePropagation();
            
            const baseUrl = window.location.origin;
            const targetUrl = url.startsWith('/') ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
            const finalUrl = `${targetUrl}?view=${page}`;
            
            console.log("BM Redirecting to:", finalUrl);
            window.location.href = finalUrl;
        }
    };

    // Registra o evento de forma global para garantir que funcione mesmo em elementos dinâmicos
    $(document).on("click", ".btn.bm-btn-customize", handleCustomizeClick);
    
    // Tenta registrar diretamente caso o elemento já esteja no DOM
    $(".btn.bm-btn-customize").on("click", handleCustomizeClick);
});
